import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navigation from '../../Components/Navigation';
import './EditeProducts.css';
import { FaTimes } from 'react-icons/fa';

const EditProducts = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    category: 'Basic',
    features: [''],
    icon: 'basic'
  });

  // Simulated product data fetch
  useEffect(() => {
    // Replace with actual API call
    const fetchProduct = async () => {
      try {
        setLoading(true);
        // Simulate API call
        const mockProduct = {
          id: 1,
          name: 'Basic Plan',
          description: 'Perfect for beginners starting their investment journey',
          price: '999',
          category: 'Basic',
          features: [
            'Basic Stock Research',
            'Daily Market Updates',
            'Email Support',
            'Basic Portfolio Tracking',
            'Weekly Newsletter'
          ],
          icon: 'basic'
        };
        
        setFormData(mockProduct);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch product details');
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFeatureChange = (index, value) => {
    const updatedFeatures = [...formData.features];
    updatedFeatures[index] = value;
    setFormData(prev => ({
      ...prev,
      features: updatedFeatures
    }));
  };

  const addFeature = () => {
    setFormData(prev => ({
      ...prev,
      features: [...prev.features, '']
    }));
  };

  const removeFeature = (index) => {
    setFormData(prev => ({
      ...prev,
      features: prev.features.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Replace with actual API call
      console.log('Submitting updated product:', formData);
      // Navigate back to products page after successful update
      navigate('/products');
    } catch (err) {
      setError('Failed to update product');
    }
  };

  if (loading) {
    return (
      <div className="page-container">
        <Navigation />
        <div className="loader-container">
          <div className="circular-loader"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-container">
        <Navigation />
        <div className="error-message">{error}</div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <Navigation />
      <div className="edit-products-container">
        <div className="edit-header">
          <h1>Edit Subscription Plan</h1>
        </div>
        
        <form onSubmit={handleSubmit} className="edit-form">
          <div className="form-group">
            <label>Plan Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter plan name"
              required
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Enter plan description"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Price (₹)</label>
              <input
                type="text"
                name="price"
                value={formData.price}
                onChange={handleInputChange}
                placeholder="Enter price"
                required
              />
            </div>

            <div className="form-group">
              <label>Category</label>
              <select
                name="category"
                value={formData.category}
                onChange={handleInputChange}
                required
              >
                <option value="Basic">Basic</option>
                <option value="Professional">Professional</option>
                <option value="Premium">Premium</option>
              </select>
            </div>

            <div className="form-group">
              <label>Icon</label>
              <select
                name="icon"
                value={formData.icon}
                onChange={handleInputChange}
                required
              >
                <option value="basic">Basic</option>
                <option value="professional">Professional</option>
                <option value="premium">Premium</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label>Features</label>
            <div className="features-container">
              {formData.features.map((feature, index) => (
                <div key={index} className="feature-input-group">
                  <input
                    type="text"
                    value={feature}
                    onChange={(e) => handleFeatureChange(index, e.target.value)}
                    placeholder="Enter feature"
                    required
                  />
                  {formData.features.length > 1 && (
                    <button
                      type="button"
                      className="remove-feature-btn"
                      onClick={() => removeFeature(index)}
                    >
                      <FaTimes />
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                className="add-feature-btn"
                onClick={addFeature}
              >
                + Add Feature
              </button>
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={() => navigate('/products')}>
              Cancel
            </button>
            <button type="submit" className="save-btn">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProducts;
